import type { StopoverPresence } from './flightFilters';

export interface StopoverPresenceToggleProps {
  value: StopoverPresence;
  onChange: (next: StopoverPresence) => void;
}

const OPTIONS: { value: StopoverPresence; label: string }[] = [
  { value: 'any', label: 'Any' },
  { value: 'direct', label: 'Direct only' },
  { value: 'stopover', label: 'With stopover' },
];

export function StopoverPresenceToggle({ value, onChange }: StopoverPresenceToggleProps) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs font-medium text-gray-700">Stopover</span>
      <div className="flex flex-wrap gap-2">
        {OPTIONS.map((option) => {
          const isSelected = value === option.value;
          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={isSelected}
              onClick={() => onChange(option.value)}
              className={[
                'px-2 py-1 text-xs font-medium rounded-full border transition-colors',
                isSelected
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50',
              ].join(' ')}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
